export default __webpack_public_path__ + "assets/favicon-16x16.94b5ad0f0e95d0cbf083b193e565f968.png";